import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatErr } from "@/lib/api";
import { Truck, Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      if (!r.data?.role) throw new Error("Login failed");
      toast.success("Signed in");
      nav("/admin");
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#111111] ff-diagonal-bg text-white flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white text-[#111] p-8 border border-[#e5e5e5]" data-testid="admin-login-form">
        <div className="flex flex-col items-center mb-6">
          <img src="/forkfix-logo.png" alt="Forkfix" className="h-16 w-auto" />
          <div className="mt-3 text-[11px] uppercase tracking-[0.25em] text-[#666] font-bold">Admin Portal</div>
        </div>
        <label className="ff-label">Email</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="ff-input mb-4" required data-testid="admin-email" />
        <label className="ff-label">Password</label>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="ff-input mb-6" required data-testid="admin-password" />
        <button disabled={busy} className="ff-btn-primary w-full justify-center disabled:opacity-60" data-testid="admin-signin"><Lock className="w-4 h-4" /> {busy ? "Signing in…" : "Sign In"}</button>
      </form>
    </div>
  );
}
